export class DelaysMetrics {
  TOTAL_M2_COUNT: number;
  M2_DELAY_COUNT: number;
  M2_CANCEL_COUNT: number;
  TOTAL_M2_MINUTES: number;
  AVG_M2_MINUTES: number;
  TOTAL_M2_COST: number;
  AVG_M2_COST: number;
  M4_COUNT: number;
  SIG_EVENT_COUNT: number;
  SIG_EVENT_SUM: number;
  IFSD_COUNT: number;
  ATB_COUNT: number;
  RTO_COUNT: number;
  DIV_COUNT: number;
  BTB_COUNT: number;
  SWAPPED_ACN_COUNT: number;
}
